import { Pipe, PipeTransform } from '@angular/core';

export function stripEmailMarkup(value: string): string {
  if (!value) return value;

  const parsed = new DOMParser().parseFromString(value, 'text/html');
  return (parsed.body.textContent ?? '')
    .trim()
    .replace(/\n{3,}/g, '\n\n');
}

@Pipe({
  name: 'stripEmailMarkup',
  standalone: true,
})
export class StripEmailMarkupPipe implements PipeTransform {
  transform(value: string): string {
    return stripEmailMarkup(value);
  }
}
